//
//
//
//
//
//

import '../../styles/App.scss'

export default {
  name: 'Index'
}
